import { ChevronDownIcon } from "@chakra-ui/icons";
import { SelectInput, type OptionsGroup } from "components/inputs/select-input";

type BaseCustomSelectorProps = {
  selectedValue: string | null;
  optionGroups: OptionsGroup<string>[];
  handleOnChange: (value: string, label: string) => void;
  title: string;
};

export function BaseCustomSelector({
  selectedValue,
  optionGroups,
  handleOnChange,
  title,
}: BaseCustomSelectorProps) {
  return (
    <SelectInput
      optionGroups={optionGroups}
      menuItemProps={{ my: 2, borderRadius: "md" }}
      menuListProps={{ px: 2, maxH: "60vh", overflowY: "auto" }}
      value={selectedValue}
      onChange={handleOnChange}
      menuProps={{
        matchWidth: true,
        gutter: 0,
        autoSelect: false,
        isLazy: true,
      }}
      menuButtonProps={{
        variant: "ghost",
        fontSize: "2xl",
        w: "100%",
        textAlign: "left",
        color: "client.navigation.text.primary",
        _hover: {
          backgroundColor: "client.navigation.hover.background",
          color: "client.navigation.hover.text",
        },
        _active: {
          backgroundColor: "client.navigation.hover.background",
          borderColor: "client.navigation.active.background",
          color: "client.navigation.hover.text",
          py: 2,
          h: "auto",
          colorScheme: "gray",
          borderWidth: "2px",
        },
      }}
      overlineTextColor={"client.navigation.text.secondary"}
      overlineText={title}
      rightIcon={<ChevronDownIcon boxSize={"18px"} />}
    />
  );
}
